export const ChatMode = {
  CLIENT: 'CLIENT',
  DOCUMENT: 'DOCUMENT',
} as const;

export type ChatMode = (typeof ChatMode)[keyof typeof ChatMode];

export const ChatState = {
  THINKING: 'THINKING',
  ANSWERING: 'ANSWERING',
  EDITING: 'EDITING',
  FINAL: 'FINAL',
  CANCELLED: 'CANCELLED',
  TOOL_STARTED: 'TOOL_STARTED',
  TOOL_FINISHED: 'TOOL_FINISHED',
  TOOL_LIMIT_REACHED: 'TOOL_LIMIT_REACHED',
  FILE_PRESENTED: 'FILE_PRESENTED',
} as const;

export type ChatState = (typeof ChatState)[keyof typeof ChatState];

export type FinalChunkData = {
  conversationId: string;
  editedContent: string;
  editedContentWithMarkers?: string | null;
  assistantMessage: string;
  versionId: string | null;
  versionNumber: number | null;
  versioningFailed: boolean;
};

export enum MessageDirection {
  Incoming = 'incoming',
  Outgoing = 'outgoing',
}

export type MessageState = 'SENT' | 'ANSWERING' | 'THINKING' | string;

export type MessageContent = { state: MessageState; content: string };

export type PresentedFile = { description: string; url: string };

export type ChatMessage = {
  kind: 'message';
  id: string;
  response: MessageContent[];
  sender: string;
  direction: MessageDirection;
  thinkingContent: string;
  answerContent: string;
  currentState: MessageState;
  currentToolName?: string;
  presentedFiles?: PresentedFile[];
};

type InterruptedMarker = {
  kind: 'interrupted';
  id: string;
};

export type Message = ChatMessage | InterruptedMarker;

export const isChatMessage = (m: Message): m is ChatMessage => m.kind === 'message';

export type StoredMessage = {
  role: string;
  content?: string | null;
};
